import { Col, Row } from "react-bootstrap";
import "./style.css";

const Flag = (props) => {

    const {
        inputParam_Code = null,
    } = props;

    const flagStyle = {
        width: "25px",
        height: "25px",
        backgroundColor: "grey",
        borderRadius: '10%',
        padding: '5px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        FontSizes: '12px'
    };

    return (
        <Row className='py-1 pe-2' style={{borderBottom: "2px solid #c8c3c3 !important"}}>
            <Col className='col-auto'>
                <div style={flagStyle}>
                    <div style={{ fontWeight: "bold", color: "white" }}>{inputParam_Code}</div>
                </div>
            </Col>
        </Row>
    )
}

export default Flag
